angular.module('plagiat2017App')
    .component('addReviewerManuallyModal', {
        templateUrl: 'app/account/assignments/peer-review/manual-assigment/add-reviewer.controller.html',
        controller: AddReviewerManuallyController,
        controllerAs: 'vm'
    });

AddReviewerManuallyController.$inject = ['$mdDialog', 'items'];

function AddReviewerManuallyController($mdDialog, items) {
    var vm = this;

    vm.docOwnerEmail = items.email;
    vm.docOwnerFullName = items.fullName;
    vm.reviewers = items.reviewers;
    vm.manuallyAssigned = items.manuallyAssigned;
    vm.max = items.max;
    vm.disabled = items.disabled;
    vm.checked = {};

    this.$onInit = function () {
        for (var i = 0; i < vm.manuallyAssigned.length; i++) {
            const assign = vm.manuallyAssigned[i];
            for (var j = 0; j < vm.reviewers.length; j++) {
                if (vm.reviewers[j].email === assign.email) {
                    vm.checked[j] = true;
                    break;
                }
            }
        }
    };

    vm.getSelected = function() {
        const selected = [];
        for (var i = 0; i < vm.reviewers.length; i++) {
            if (vm.checked[i]) {
                selected.push(vm.reviewers[i]);
            }
        }
        return selected;
    };

    vm.confirm = function() {
        $mdDialog.hide(vm.getSelected());
    }

    vm.cancel = function() {
        return $mdDialog.hide();
    }

}
